import AddressHistoryModal from './AddressHistoryModal'

export default AddressHistoryModal
